// import '@mdi/font/css/materialdesignicons.min.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import dark from './theme'

Vue.use(Vuetify)

const opts = {
  // icons: {
  //   iconfont: 'mdi', // default - only for display purposes
  // },  
  theme: {
    options: {
      customProperties: true,
    },
    dark: true,
    themes: { dark }
  },
}

export default new Vuetify(opts)